import "./GenaralStyles/InputFile.scss"
import { textAlign } from "@mui/system";
import { Button, Row, Upload } from "antd";
import React from "react";
import { useState } from "react";
import Adjuntar from "../../Img/Iconos/AdjuntarArchivo.svg";
import Eliminar from "../../Img/Iconos/eliminar.svg";
import Icono from "../IconosDeSitio";
import { AttachFile, OndemandVideo } from "@mui/icons-material";
import { Image, message } from "antd";
import { useSelector, useDispatch } from 'react-redux';
import { showSnackbar } from '../../redux/snackbarSlice';

export default function ButtonSingleFile({
    texto,
    archivo,
    formatos,
    extras,
    archivoValue,
    id,
    mensajes,
    buttonStyle,
    title,
    classnameButton,
}) {
    const dispatch = useDispatch();
    // subir Archivos lista
    const [OpenArchivo, setOpenArchivo] = useState(1);
    const [Archivo, setArchivo] = useState({
        uid: id,
        name: archivoValue !== undefined ? archivoValue.name : "",
        url: archivoValue !== undefined ? archivoValue.url : "",
        file: "",
        size: 0,
        formato: archivoValue !== undefined ? archivoValue.formato : "",
        status: archivoValue !== undefined ? "done" : "",
        thumbUrl: archivoValue !== undefined ? archivoValue.url : "",
    });
    const changeInput = (e) => {

        let formato = e.type.split("/");
        let fileSize = ((e.size / 1024) / 1024);

        switch (formatos) {
            case 1:
                if (formato[1] === "jpeg" || formato[1] === "png") {
                    if (fileSize <= 5) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El archivo excede el tamaño maximo permitido (5MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: "Tipo de archivo no valido. Archivos permitidos: imagenes ( png, jpeg )",
                        type: "warning",
                    }));
                }
                break;
            case 2:
                if (formato[0] === "video") {
                    if (fileSize <= 10) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El video excede el tamaño maximo permitido (10MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: "Tipo de archivo no valido. Archivos permitidos: videos",
                        type: "warning",
                    }));
                }
                break;
            case 3:
                if (formato[1] === "pdf") {
                    if (fileSize <= 5) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El archivo excede el tamaño maximo permitido (5MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: "Tipo de archivo no valido. Archivos permitidos: archivos (pdf)",
                        type: "warning",
                    }));
                }
                break;
            case 4:
                if (
                    formato[1] === "pdf" ||
                    formato[1] === "jpeg" ||
                    formato[1] === "png"
                ) {
                    if (fileSize <= 5) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El archivo excede el tamaño maximo permitido (5MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: "Tipo de archivo no valido. Archivos permitidos: imagenes y archivos ( png, jpeg, pdf )",
                        type: "warning",
                    }));
                }
                break;
            case 5:
                if (
                    formato[1] === "pdf" ||
                    formato[1] === "jpeg" ||
                    formato[1] === "png" ||
                    formato[1] === "doc" ||
                    formato[1] === "docx" ||
                    formato[1] === "msword" ||
                    formato[1] ===
                    "vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                    formato[1] === "jpg"
                ) {
                    if (fileSize <= 5) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El archivo excede el tamaño maximo permitido (5MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    if (formato[0] === "video") {
                        if (fileSize <= 10) {
                            let newImgsToState = readmultifiles(e);
                            setArchivo(newImgsToState);
                            archivo(newImgsToState);
                            setOpenArchivo(1);
                            if (extras[3] !== undefined) {
                                extras[3]("true");
                            }
                        } else {
                            dispatch(showSnackbar({
                                show: true,
                                text: "El video excede el tamaño maximo permitido (10MB)",
                                type: "warning",
                            }));
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "Tipo de archivo no valido. Archivos permitidos: imagenes, archivos y videos ( png, jpeg, pdf, doc, docx )",
                            type: "warning",
                        }));
                    }
                }
                break;

            default:
                if (
                    formato[1] === "pdf" ||
                    formato[1] === "jpeg" ||
                    formato[1] === "png" ||
                    formato[1] === "doc" ||
                    formato[1] === "docx" ||
                    formato[1] === "msword" ||
                    formato[1] ===
                    "vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                    formato[1] === "jpg"
                ) {
                    if (fileSize <= 5) {
                        let newImgsToState = readmultifiles(e);
                        setArchivo(newImgsToState);
                        archivo(newImgsToState);
                        setOpenArchivo(1);
                        if (extras[3] !== undefined) {
                            extras[3]("true");
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "El archivo excede el tamaño maximo permitido (5MB)",
                            type: "warning",
                        }));
                    }
                } else {
                    if (formato[0] === "video") {
                        if (fileSize <= 10) {
                            let newImgsToState = readmultifiles(e);
                            setArchivo(newImgsToState);
                            archivo(newImgsToState);
                            setOpenArchivo(1);
                            if (extras[3] !== undefined) {
                                extras[3]("true");
                            }
                        } else {
                            dispatch(showSnackbar({
                                show: true,
                                text: "El video excede el tamaño maximo permitido (10MB)",
                                type: "warning",
                            }));
                        }
                    } else {
                        dispatch(showSnackbar({
                            show: true,
                            text: "Tipo de archivo no valido. Archivos permitidos: imagenes, archivos y videos ( png, jpeg, pdf, doc, docx )",
                            type: "warning",
                        }));
                    }
                }
                break;
        }
    };

    function readmultifiles(e) {
        let arrayImages = "";
        let url = URL.createObjectURL(e);
        let formato = e.type.split("/");
        arrayImages = {
            uid: e.uid,
            name: e.name,
            url: url,
            file: e,
            size: e.size,
            formato: formato[1],
            status: "done",
            thumbUrl: url,
        };

        return arrayImages;
    }

    function formatValidation(value) {
        switch (formatos) {
            case 1:
                return value.split("/")[0] === 'image';
            case 2:
                return value.split("/")[0] === 'video';
            case 3:
                return value.split("/")[1] === 'pdf';
            case 4:
                return value.split("/")[0] === 'image' || value.split("/")[1] === 'pdf';
            case 5:
                return value.split("/")[0] === 'image' || value.split("/")[0] === 'video' || value.split("/")[1] === 'pdf'
                    || value.split("/")[1] === 'doc' || value.split("/")[1] === 'docx' || value.split("/")[1] === 'msword'
                    || value.split("/")[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document';

            default:
                return value.split("/")[0] === 'image' || value.split("/")[0] === 'video' || value.split("/")[1] === 'pdf'
                    || value.split("/")[1] === 'doc' || value.split("/")[1] === 'docx' || value.split("/")[1] === 'msword'
                    || value.split("/")[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document';
        }
    }

    return (
        <Upload
            beforeUpload={file => {
                const isImage = formatValidation(file.type);
                if (!isImage) {
                    message.error(`${file.name} no es una imagen`);
                    return Upload.LIST_IGNORE;
                }
                changeInput(file);
                return false;
            }}
            // listType=""
            maxCount={1}
            id={id !== undefined ? id : "buttonSingleFile"}
            fileList={Archivo.url ? [Archivo] : []}
            onRemove={(value) => {
                console.log(value);
                setArchivo({
                    uid: "",
                    name: "",
                    url: "",
                    file: "",
                    size: 0,
                    formato: "",
                    status: "",
                    thumbUrl: "",
                })

            }}
        // showUploadList={{ showRemoveIcon: Archivo.file ? true : false }}
        >
            {title !== undefined && (
                <>
                    <h3 style={{ textAlign: "center", color: "#7B7B7B" }}>{title}</h3>
                    {formatos === 1 && (
                        <label style={{ fontSize: "12px", color: "grey" }}>Nota: solo se permiten archivos de tipo imagen (jpg, png, jpeg).</label>
                    )}
                    <br />
                </>
            )}



            <div style={{ display: "flex", justifyContent: "center" }}>
                <Button className={`roundedButtonBlue ${classnameButton}`} style={buttonStyle}>
                    <AttachFile /> {texto !== undefined ? texto : "Adjuntar"}
                </Button>
            </div>
        </Upload >
    );
}
